<template lang='pug'>
  form.forms.coupon.component.container(@submit.prevent='make')
    close-button( @click.native='$emit("close")' )

    header.heading
      h3 {{ $t('Add a Coupon') }}

    section.fields
      .fields-container 
        fieldset
          label {{ $t('Type') }}
          bf-input.basic
            select( v-model='item.type' required )
              option( value='discount' ) {{ $t('Discount') }}
        fieldset
          label {{ $t('Status') }}
          bf-input.basic
            select( v-model='item.status' required )
              option( value='active' ) {{ $t('Active') }}
              option( value='inactive' ) {{ $t('Inactive') }}
      
      fieldset
        input(
          type='file'
          ref='upload'
          style='display: none'
          accept='image/*'
          multiple
          :key='key'
          @change='upload' 
        )
        .image.container.actionable( @click='$refs.upload.click()' )
          .delete(@click='')
            delete-icon
          img(:src='image.src')

      .fields-container
        fieldset
          label {{ $t('Starts On 00:00 AM') }}
          bf-input.basic
            datetime(v-model='item.start' :placeholder='$t("Set Start Date")' required )          
        fieldset
          label {{ $t('Ends On 12:59 PM') }}
          bf-input.basic
            datetime(v-model='item.end' :placeholder='$t("Set End Date")' required )
      
      fieldset
        label {{ $t('Title/Name of Coupon') }}
        bf-input.basic
          input( type='text' v-model='item.title' required :placeholder="$t('Enter Title of Coupon')" )

      fieldset
        label {{ $t('$ Amount or % Discount') }}
        bf-input.basic
          input( type='text' v-model='item.amount' required :placeholder="$t('$ or %')" min='1' max='100' step='1' )

      fieldset
        label {{ $t('Description') }}
        textarea( v-model='item.description' :placeholder="$t('Optional Description...')" )

    footer
      fieldset.centered-text
        bf-button.wide(type='submit')
          template(v-slot:text) {{ $t(text) }}
</template>

<script>
  import { db, str } from '@/main'
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'forms.coupon',

    components: {
      CloseButton
    },

    props: {
      // merchant: { type: Object, required: true },
      biz: { required: true},
      user: { type: Object, required: true },
      account: { type: Object, required: true },
    },

    data() {
      return {
        text: this.$t('Create'),
        item: { type: 'discount', status: 'active' },
        key: 0,
        image: { src: 'no-image.png' }
      }
    },

    methods: {
      make() {
        this.text = 'Creating...'

        let file = this.$refs.upload.files[0]
        if ( file ) {
          let ref = str.ref(`/coupons/${this.user.uid}/${new Date().getTime()}/${file.name}`)
          ref.put(file).then( snap =>
            snap.ref.getDownloadURL().then( url => 
              db.collection( 'coupons' ).add({ 
                image: {src: url}, 
                uid: this.user.uid, 
                account: this.account, 
                biz: this.biz, 
                ...this.item 
              }).then( doc => {
                this.item = { type: 'discount' }
                this.image = { src: 'no-image.png' }
                this.text='Create'
                this.$emit( 'close' )
              })
            )
          )
        }
        else db.collection( 'coupons' ).add({ 
          uid: this.user.uid, 
          account: this.account, 
          biz: this.biz, 
          ...this.item 
        }).then( doc => {
          this.item = { type: 'discount' }
          this.image = { src: 'no-image.png' }
          this.text='Create'
          this.$emit( 'close' )
        })
      },

      upload(e) {
        Array.from( e.target.files ).forEach( file => {
          let reader  = new FileReader()
          reader.addEventListener('load', () => {
            this.image = { src: reader.result } 
            this.$emit('changed')
          }, false)
          reader.readAsDataURL(file)
        })
      },

      del(image, i) {
        db.collection( this.collection ).doc( this.pid ).collection( 'images' ).doc( image.id ).delete()
      }
    }
  }
</script>

<style scoped lang="stylus">
  textarea
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 97.5%
  
  .forms.coupon
    background white
    border-radius 9px
    min-width 400px
    max-width 420px
    @media( max-width: 480px )
      min-width 0

    header
      padding 16px 32px
      background rgba( 0 0 0 .1 )
      border-bottom 1px solid rgba( 0 0 0 .25 )

    footer
      border-top 1px solid rgba( 0 0 0 .25 )

    header, footer
      box-shadow var(--shadow-box-shallow)

    section
      max-height calc( 100vh - 280px )
      overflow-y auto

    fieldset
      padding 10px 10px

    label
      display block
      font-weight bold
      margin 8px 2px
      &:first-child 
        margin-top 0
    
    .fields-container
      display grid
      grid-template-columns repeat( auto-fit, minmax( 192px, 1fr ) )
      fieldset:last-child
        // text-align right
        
    .image.container
      margin-left auto
      width 100%
      border-radius 5px
      overflow hidden
      // border 2px solid rgba( 0 0 0 .25 )
      box-shadow var(--shadow-box-shallow)
      @media( max-width: 383px )
        margin 0 auto
    .delete
      position absolute
      font-size 1.5em
      color white
      padding 8px 12px
      background rgba( 0 0 0 .25 )
      top 0
      right 0
      border-radius 0 0 0 13px
      box-shadow var(--shadow-box-shallow)
    img 
      object-fit cover
      width 100%
      display block

    
    .close
      position absolute
      right 15px
      top 15px
      background white
</style>